//@flow
import React from 'react';
import CategoryCard from '../../Category/components/CategoryCard.react';
import type CategoryModel from '../../Stores/MemberCategories/categoryModel';

function renderCategoryCard(category:CategoryModel, currentCategory:CategoryModel, isOffice?:boolean) {
  if (category === currentCategory || !category.showCategoryThumbnail()) {
    return null;
  }

  return (
    <CategoryCard
      category={category}
      key={category.getId()}
      isOffice={isOffice}
    />
  );
}

type Props = {
  categories:CategoryModel[],
  currentCategory:CategoryModel,
  isOffice?:boolean,
};

export default function OtherCategories(props:Props) {
  return (
    <section className="other-categories">
      <h2 className="other-categories-header">Other Categories</h2>
      <ul className="row gallery-grid-sm-2 gallery-grid-lg-3">
        {props.categories.map((category) => renderCategoryCard(category, props.currentCategory, props.isOffice))}
      </ul>
    </section>
  );
}
